import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Select } from '@/shared/components/Select'
import { THEMES, THEME_PREVIEWS } from '@/shared/theme/theme'
import { useTheme } from '@/shared/theme/theme-context'

/**
 * Theme dropdown on the shared Select: each planet with its own primary
 * color as a swatch. Same labels as the Settings theme cards.
 */
export function ThemeSwitcher() {
  const { t } = useTranslation(['settings', 'common'])
  const { theme, setTheme } = useTheme()
  const options = useMemo(
    () =>
      THEMES.map((kind) => ({
        value: kind,
        label: t(`settings:themes.${kind}`),
        leading: (
          <span
            aria-hidden
            className="size-3 rounded-full ring-1 ring-white/30"
            style={{
              background: `linear-gradient(135deg, ${THEME_PREVIEWS[kind].primary}, ${THEME_PREVIEWS[kind].secondary})`,
            }}
          />
        ),
      })),
    [t],
  )

  return (
    <Select
      value={theme}
      onChange={setTheme}
      options={options}
      size="sm"
      align="end"
      fullWidth={false}
      aria-label={t('common:actions.theme')}
      className="font-semibold"
    />
  )
}
